import { schema, normalize } from 'normalizr';
import { createActions, asyncAction } from '../helpers/redux';
import qs from 'qs';

import { AppActions } from '../actions/app';

const avatarSchema = new schema.Entity('avatars');
const userSchema = new schema.Entity('users');
const projectSchema = new schema.Entity('projects', {
  user: userSchema,
});

const accountSchema = new schema.Entity('accounts');

userSchema.define({
  avatar: avatarSchema,
});

export const AuthActions = createActions({
  moo() {
    return { result: true };
  },

  @asyncAction()
  async logout() {
    return ({ client, dispatch }) => {
      dispatch(AppActions.globalResetReducers());
      client.get('/user/logout');
    };
  },

  setAuthToken(accessToken) {
    return { accessToken };
  },

  @asyncAction()
  async authenticate(email, password) {
    return ({ client }) => {
      return client
        .post('/oauth/token', {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: qs.stringify({
            client_id: 'lattix_web_client',
            client_secret: 'secret',
            grant_type: 'password',
            username: email,
            password: password,
          }),
        })
        .then(function(result) {
          return result;
        })
        .catch(function(error) {
          throw error;
        });
    };
  },

  @asyncAction()
  async getMe() {
    return ({ client }) => {
      return client.get('/user/me').then(function(response) {
        return normalize(response, userSchema);
      });
    };
  },

  @asyncAction()
  async getMeProjects() {
    return async ({ client }) => {
      const response = await client.get('/users/me/projects');
      // debugger;
      return normalize(response, [projectSchema]);
    };
  },

  @asyncAction()
  async getMeAccounts() {
    return async ({ client }) => {
      const response = await client.get('/users/me/accounts', {
        qs: {
          fields: ['account_count'],
        },
      });
      return normalize(response, [accountSchema]);
    };
  },

});



// WEBPACK FOOTER //
// ./src/actions/auth.js